export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  const number = Number(num);
  
  if (number >= 1000000) {
    const millions = number / 1000000;
    return millions % 1 === 0 ? `${millions}M` : `${millions.toFixed(1)}M`;
  }
  
  if (number >= 1000) {
    const thousands = number / 1000;
    return thousands % 1 === 0 ? `${thousands}K` : `${thousands.toFixed(1)}K`;
  }
  
  return number.toString();
};

